import React, { Component } from "react";
import { rangeMapper, clamp } from "../Utils/Functions";

export default class Video extends Component {
  constructor(props) {
    super(props);
    this.vid = React.createRef();
    this.state = {
      scroll: 0,
      isFirefox: false,
      isTouchEnabled: false,
    };
  }
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    const isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
    this.setState({
      isFirefox: isFirefox,
      isTouchEnabled: this.is_touch_enabled(),
    });
  }
  is_touch_enabled() {
    return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const { isFirefox, isTouchEnabled } = this.state;
    let scroll = window.scrollY;
    //console.log("scroll ",scroll, window.innerHeight)

    let offset =
      this.vid.current.getBoundingClientRect().top - window.innerHeight / 3;
    let calc = 0;
    if (isFirefox || isTouchEnabled) {
      calc = 3;
    } else {
      calc = clamp(
        rangeMapper(offset, 0, -window.innerHeight, 0, 5),
        0,
        5
      ).toFixed(2);
    }

    if (this.vid.current.currentTime !== undefined) {
      this.vid.current.currentTime = calc;
    }
  };

  render() {
    return (
      <>
        <video ref={this.vid}>
          <source src="./assets/video/Audi.mp4" type="video/mp4" />
        </video>
      </>
    );
  }
}
